import Vue from 'vue';
import Buefy from 'buefy';

Vue.use(Buefy, {
  defaultIconPack: 'fa'
});
